import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Collapse from 'blocks.simple/collapse/collapse'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { grid } from '../../../theme'
import { updateCompany } from 'blocks.app/user/user.state'
import styles from '../settings.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import { getURLSearchParamsByLocation } from '../../../features/routes/utils'

const BroadcastEvents = ({ broadcastEventsStorageDays }: { broadcastEventsStorageDays: number }) => {
    const dispatch = useDispatch()
    const [days, setDays] = useState<string>(
        (broadcastEventsStorageDays && broadcastEventsStorageDays.toString()) || '30'
    )
    const url = window.location.hash
    const [hash, query] = url.split('#')[1].split('?')
    const params = Object.fromEntries(new URLSearchParams(query))

    useEffect(() => {
        if (+days === (broadcastEventsStorageDays || 30)) return

        const timeout = setTimeout(() => {
            dispatch(
                updateCompany({
                    data: { broadcastEventsStorageDays: +days },
                    isSaveCompany: true,
                })
            )
        }, 400)

        return () => clearTimeout(timeout)
    }, [days])

    return (
        <Collapse
            title={() => translate('broadcastEvents')}
            className={cn(styles.background, grid.mb_md)}
            initialOpen={!!(params && params.open && params.open === 'broadcastEvents')}
        >
            <div className={cn(grid.mb_md, grid.mt_mini)}>{translate('eventsLogsStorageTime')}:</div>
            <div className={cn(grid.row)}>
                <div style={{ width: 300 }}>
                    <EditText
                        type={'number'}
                        value={days}
                        mod="withBorder"
                        onChange={(value: string) => {
                            setDays(value)
                        }}
                    />
                </div>
            </div>
        </Collapse>
    )
}

export default BroadcastEvents
